<template>
  <div>
    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Users"
      selectedOptionsHeading="Current Admins" :initial-skills="availableAllUsers" :showDefaultMessage="false"
      v-model:interests="currentAdmins" :onSave="readOnly ? null : handleSaveActivities" :loading="loading" :isSaving="submitting"
      :disabled="readOnly" />
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";

defineProps({
    readOnly: { type: Boolean, default: false }
});

const store = useStore();
const route = useRoute();
const toast = useToast();

// ✅ Get IDs from route params
const locationId = route.params.locationid;
const instanceId = route.params.activityinstanceid;

// ✅ Reactive state
const availableAllUsers = ref([]); // all users
const currentAdmins = ref([]); // current instance admins

const loading = computed(() => store.getters.instanceLoading);
const submitting = ref(false);

// ✅ Load instance admins
const loadInstanceAdmins = async () => {
  try {
    const data = await store.dispatch("getInstanceAdmins", {
      locationId,
      instanceId,
    });

    // ✅ Map data for TagSelector
    // Response structure: { all_users: [...], current_admins: [...] }
    const allUsers = data?.all_users || [];
    const currentAdminsList = data?.current_admins || [];

    availableAllUsers.value = allUsers.map((u) => ({
      id: u.personid,
      name: `${u.firstname} ${u.lastname}`,
      description: u.email || "",
    }));

    currentAdmins.value = currentAdminsList.map((u) => ({
      id: u.personid,
      name: `${u.firstname} ${u.lastname}`,
      description: u.email || "",
    }));
  } catch (error) {
    console.error("Failed to load instance admins:", error);
    toast.error("Failed to load instance admins", { position: "top-right" });
  }
};

// ✅ Save handler for instance admins
const handleSaveActivities = async (selected) => {
  submitting.value = true;
  try {
    const userIds = selected.map((x) => x.id);

    await store.dispatch("saveInstanceAdmins", {
      locationId,
      instanceId,
      userIdsArray: userIds,
    });

    toast.success("Instance admins saved successfully", { position: "top-right" });

    // Reload data after successful save
    await loadInstanceAdmins();
  } catch (error) {
    console.error("Failed to save instance admins:", error);
    toast.error("Failed to save instance admins", { position: "top-right" });
  } finally {
    submitting.value = false;
  }
};

onMounted(async () => {
  await loadInstanceAdmins();
});
</script>